import { pxToRem, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const starRatingContainer = css`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
`;

export const stars = css`
  margin: ${stack(spacing.md)};
`;

export const starRating = css`
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  margin-right: ${pxToRem(spacing.base)};

  &:nth-child(5) {
    margin-right: ${pxToRem(spacing.xs)};
  }
`;

export const reviewsText = css`
  font-size: ${pxToRem(text.xxs.SMALL.fontSize)};
`;
